export default "__VITE_ASSET__fdb43d9f__"